// extracted by mini-css-extract-plugin
module.exports = {"selectBackground":"styles_selectBackground__PnrGw"};